export interface IAPICollectionResponse<T> {
  value: T[];
  count: number;
  nextLink?: string;
}
